document.addEventListener('DOMContentLoaded', function () {
	const filter = document.querySelector('.category-filters__select');
	if (!filter) return;

	const choice = filter.querySelector('.category-filters__select__choice');
	const dropdown = filter.querySelector('.category-filters__select__dropdown');
	const options = dropdown ? dropdown.querySelectorAll('.category-filters__select__option') : [];
	const pageCards = document.querySelectorAll('.page-card');
	const onderwerpChoice = document.querySelector('.onderwerpen-filters__select__choice');
	const categoryChoice = document.querySelector('.category-filters__select__choice');
	const listContainer = document.querySelector('.kennis-list__items, .news-list__items, .list-children__list');
	const clearButtonContainer = document.querySelector('.category-filters') || document.querySelector('.onderwerpen-filters');

	if (choice && !choice.getAttribute('data-default-label')) {
		choice.setAttribute('data-default-label', choice.textContent.trim());
	}
	if (onderwerpChoice && !onderwerpChoice.getAttribute('data-default-label')) {
		onderwerpChoice.setAttribute('data-default-label', onderwerpChoice.textContent.trim());
	}

	const noResultsCard = ensureNoResultsCard();
	const clearFiltersButton = ensureClearFiltersButton();

	choice.addEventListener('click', function (e) {
		e.stopPropagation();
		dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
		filter.classList.toggle('open');
	});

	options.forEach(option => {
		option.addEventListener('click', function (e) {
			e.stopPropagation();
			const label = option.textContent;
			const filterValue = option.getAttribute('data-filter');

			choice.textContent = label;
			choice.setAttribute('data-selected-filter', filterValue);

			dropdown.style.display = 'none';
			filter.classList.remove('open');

			filterPageCards();
			document.dispatchEvent(new Event('filters:changed'));
		});
	});

	document.addEventListener('click', function (e) {
		if (!filter.contains(e.target)) {
			dropdown.style.display = 'none';
			filter.classList.remove('open');
		}
	});

	document.addEventListener('filters:changed', function () {
		filterPageCards();
	});

	function filterPageCards() {
		const selectedOnderwerp = onderwerpChoice ? onderwerpChoice.getAttribute('data-selected-filter') || 'all' : 'all';
		const selectedCategory = categoryChoice ? categoryChoice.getAttribute('data-selected-filter') || 'all' : 'all';
		let visibleCount = 0;

		pageCards.forEach(card => {
			if (card.classList.contains('page-card--no-results')) {
				return;
			}

			const cardOnderwerp = card.getAttribute('data-onderwerp');
			const cardCategory = card.getAttribute('data-category');
			const onderwerpValues = (cardOnderwerp || '').split(',').map(value => value.trim()).filter(Boolean);
			const onderwerpMatch = selectedOnderwerp === 'all' || onderwerpValues.includes(selectedOnderwerp);
			const categoryMatch = selectedCategory === 'all' || cardCategory === selectedCategory;
			const isVisible = onderwerpMatch && categoryMatch;

			card.style.display = isVisible ? '' : 'none';
			if (isVisible) {
				visibleCount += 1;
			}
		});

		if (noResultsCard) {
			noResultsCard.style.display = visibleCount === 0 ? '' : 'none';
		}

		if (clearFiltersButton) {
			const hasActiveFilters = selectedOnderwerp !== 'all' || selectedCategory !== 'all';
			clearFiltersButton.style.display = hasActiveFilters ? '' : 'none';
		}
	}

	function ensureNoResultsCard() {
		if (!listContainer) return null;

		let card = listContainer.querySelector('.page-card--no-results');
		if (!card) {
			card = document.createElement('div');
			card.className = 'page-card page-card--no-results';
			card.textContent = 'Geen resultaten';
			card.style.display = 'none';
			listContainer.appendChild(card);
		}
		return card;
	}

	function ensureClearFiltersButton() {
		if (!clearButtonContainer) return null;

		let button = document.querySelector('.filters-clear');
		if (!button) {
			button = document.createElement('button');
			button.type = 'button';
			button.className = 'filters-clear';
			button.textContent = 'Filters verwijderen';
			button.style.display = 'none';
			clearButtonContainer.appendChild(button);
		}

		if (!button.getAttribute('data-bound')) {
			button.addEventListener('click', function () {
				if (onderwerpChoice) {
					const defaultOnderwerpLabel = onderwerpChoice.getAttribute('data-default-label') || 'Alle onderwerpen';
					onderwerpChoice.textContent = defaultOnderwerpLabel;
					onderwerpChoice.setAttribute('data-selected-filter', 'all');
				}

				if (categoryChoice) {
					const defaultCategoryLabel = categoryChoice.getAttribute('data-default-label') || 'Alle categorieën';
					categoryChoice.textContent = defaultCategoryLabel;
					categoryChoice.setAttribute('data-selected-filter', 'all');
				}

				document.dispatchEvent(new Event('filters:changed'));
			});
			button.setAttribute('data-bound', 'true');
		}

		return button;
	}

	filterPageCards();
});
